// extracted by mini-css-extract-plugin
export default {"Eco_kitchen_box":"serach_Eco_kitchen_box__Aqg7V","left_filter_box":"serach_left_filter_box__hneCY"};